import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'assetStringPipe' })
export class AssetStringPipe implements PipeTransform {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: any) {
        //ce daljsi od 10, ga razbiješ na prve 3 crke + .. + zadne 3 crke (da ni prekrivanja tekstov na koledarju)

        value = value.replace(/ /g, '');
        if (value.length > 8) {
            return value.slice(0, 3) + '..' + '<br />' + value.slice(value.length - 4, value.length);
        } else {
            return value;
        }
    }
}
